module.exports.SAVE_CLIENT = 'SAVE_CLIENT';
module.exports.EDIT_CLIENT = 'EDIT_CLIENT';
module.exports.ADD_USAGES = 'ADD_USAGES';
module.exports.ADD_ENV = 'ADD_ENV';
module.exports.ADD_INFO = 'ADD_INFO';
module.exports.ADD_USAGE_LIMIT = 'ADD_USAGE_LIMIT';
